"use strict";

var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("prop-types");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TypographyStyle = function TypographyStyle(props) {
  return _react2.default.createElement("style", {
    id: "typography.js",
    dangerouslySetInnerHTML: {
      __html: props.typography.toString()
    }
  });
};
TypographyStyle.propTypes = {
  typography: _propTypes2.default.object.isRequired
};
TypographyStyle.displayName = "TypographyStyle";
module.exports = TypographyStyle;